import apiService from '../Api'

export default class EmployeeService {
  async list() {
    return apiService.get('/employee')
  }
}
